import { AppData } from "../AppData";
import { logEvent } from "firebase/analytics";

export class FirebaseEvents {
  static logEvent(name: string, parameters: Object) {
    if (process.env.NODE_ENV !== "production" && AppData.analytics) {
      logEvent(AppData.analytics, name, parameters);
    }
  }

  static getDeviationUpdateType(deviationUpdate: { [key: string]: any }): string {
    if (deviationUpdate.status !== undefined) return "status";
    if (deviationUpdate.comment !== undefined) return "comment";
    if (deviationUpdate.priority !== undefined) return "priority";
    if (deviationUpdate.archived !== undefined) return "archived";
    if (deviationUpdate.contractorGroups !== undefined) return "contractorGroups";
    if (deviationUpdate.floors !== undefined) return "floors";
    if (deviationUpdate.placeDescription !== undefined) return "placeDescription";
    if (deviationUpdate.startDate !== undefined) return "startDate";
    if (deviationUpdate.deadline !== undefined) return "deadline";
    if (deviationUpdate.tags !== undefined) return "tags";
    if (deviationUpdate.newTitle !== undefined) return "newTitle";
    if (deviationUpdate.newDescription !== undefined) return "newDescription";
    if (deviationUpdate.files !== undefined) return "files";

    return "";
  }
}

